export const SET_BLOCKED_NUMBERS = 'SET_BLOCKED_NUMBERS';
export const REMOVE_BLOCKED_NUMBER = 'REMOVE_BLOCKED_NUMBER';
export const ADD_BLOCKED_NUMBER = 'ADD_BLOCKED_NUMBER';
export const SEARCH_BULK_BLOCKED_NUMBER = 'SEARCH_BULK_BLOCKED_NUMBER';
export const REMOVE_BULK_BLOCKED_NUMBER = 'REMOVE_BULK_BLOCKED_NUMBER';
export const BULK_BLOCK_NUMBERS = 'BULK_BLOCK_NUMBERS';
